import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';


const VendorHero = ({ vendor, onShare, onToggleFavorite, isFavorited }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showFullGallery, setShowFullGallery] = useState(false);

  const handlePrevImage = () => {
    setCurrentImageIndex(prev => 
      prev === 0 ? vendor.gallery.length - 1 : prev - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex(prev => 
      prev === vendor.gallery.length - 1 ? 0 : prev + 1
    );
  };

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setShowFullGallery(false);
  };

  return (
    <div className="relative">
      {/* Main Gallery */}
      <div className="relative h-96 lg:h-[500px] bg-surface-100 rounded-xl overflow-hidden">
        <Image
          src={vendor.gallery[currentImageIndex]}
          alt={`${vendor.name} - Gallery Image ${currentImageIndex + 1}`}
          className="w-full h-full object-cover"
        />
        
        {/* Gallery Navigation */}
        {vendor.gallery.length > 1 && (
          <>
            <button
              onClick={handlePrevImage}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/50 hover:bg-black/70 text-white rounded-full flex items-center justify-center transition-smooth"
            >
              <Icon name="ChevronLeft" size={20} color="#FFFFFF" />
            </button>
            <button
              onClick={handleNextImage}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/50 hover:bg-black/70 text-white rounded-full flex items-center justify-center transition-smooth"
            >
              <Icon name="ChevronRight" size={20} color="#FFFFFF" />
            </button>
          </>
        )}

        {/* Gallery Counter */}
        <div className="absolute bottom-4 left-4 bg-black/70 text-white px-3 py-1 rounded-full text-sm font-data">
          {currentImageIndex + 1} / {vendor.gallery.length}
        </div>

        {/* Action Buttons */}
        <div className="absolute top-4 right-4 flex items-center space-x-2">
          <button
            onClick={onShare}
            className="w-10 h-10 bg-black/50 hover:bg-black/70 text-white rounded-full flex items-center justify-center transition-smooth"
          >
            <Icon name="Share" size={18} color="#FFFFFF" />
          </button>
          <button
            onClick={onToggleFavorite}
            className={`w-10 h-10 rounded-full flex items-center justify-center transition-smooth ${
              isFavorited 
                ? 'bg-accent text-white' :'bg-black/50 hover:bg-black/70 text-white'
            }`}
          >
            <Icon name="Heart" size={18} color="#FFFFFF" />
          </button>
        </div>

        {/* Verification Badge */}
        {vendor.isVerified && (
          <div className="absolute top-4 left-4 bg-success text-success-foreground px-3 py-1 rounded-full text-sm font-medium flex items-center space-x-1">
            <Icon name="Shield" size={14} color="#FFFFFF" />
            <span>Verified</span>
          </div>
        )}
      </div>

      {/* Thumbnail Gallery */}
      <div className="mt-4 flex space-x-2 overflow-x-auto pb-2">
        {vendor.gallery.slice(0, 8).map((image, index) => (
          <button
            key={index}
            onClick={() => handleImageClick(index)}
            className={`flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden border-2 transition-smooth ${
              index === currentImageIndex 
                ? 'border-primary' :'border-transparent hover:border-border-dark'
            }`}
          >
            <Image
              src={image}
              alt={`${vendor.name} - Thumbnail ${index + 1}`}
              className="w-full h-full object-cover"
            />
          </button>
        ))}
        
        {vendor.gallery.length > 8 && (
          <button
            onClick={() => setShowFullGallery(true)}
            className="flex-shrink-0 w-16 h-16 rounded-lg bg-surface-100 border-2 border-border hover:border-border-dark transition-smooth flex items-center justify-center"
          >
            <div className="text-center">
              <Icon name="Plus" size={16} color="#6B5B4F" />
              <div className="text-xs text-text-secondary font-data mt-1">
                +{vendor.gallery.length - 8}
              </div>
            </div>
          </button>
        )}
      </div>

      {/* Full Gallery Modal */}
      {showFullGallery && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4">
          <div className="max-w-4xl w-full">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-white font-heading font-semibold text-xl">
                {vendor.name} - Gallery
              </h3>
              <button
                onClick={() => setShowFullGallery(false)}
                className="w-10 h-10 bg-white/20 hover:bg-white/30 text-white rounded-full flex items-center justify-center transition-smooth"
              >
                <Icon name="X" size={20} color="#FFFFFF" />
              </button>
            </div>
            
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-h-96 overflow-y-auto">
              {vendor.gallery.map((image, index) => (
                <button
                  key={index}
                  onClick={() => handleImageClick(index)}
                  className="aspect-square rounded-lg overflow-hidden hover:scale-105 transition-smooth"
                >
                  <Image
                    src={image}
                    alt={`${vendor.name} - Gallery Image ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VendorHero;